/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as size from '@constant/size';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import * as animation from '@constant/animation';
import * as color from '@constant/color';

interface IProps {
  children?: React.ReactNode;
  onClick: () => void;
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: ${IS_IYAGIGO_MOBILE_VIEW ? '0' : size.WEB_SIDE_WIDTH};
  right: 0;
  bottom: 0;
  // 모바일 사이드탭(ModalBackground z-index:100) 위에 토스트가 올라오도록 101
  z-index: 101;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  align-items: center;
  background-color: ${color.MODAL_COLOR};
  // 자식 토스트가 safe-area-bottom 위에 안전하게 올라가도록
  padding-bottom: var(--sab);
  ${animation.TOAST_BACKGROUND_FADE_IN_CSS}

  // safe-area-bottom 영역에 흰색 띠 (모바일만 sab 인셋이 존재)
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: var(--sab);
    background-color: ${color.WHITE_1};
  }
`;

const ToastBackground: React.FC<IProps> = ({ children, onClick }) => {
  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClick();
    }
  };

  return (
    <Wrapper onClick={handleBackgroundClick}>
      {/* children click 시, event 중지 */}
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </Wrapper>
  );
};

export default ToastBackground;
